import { render, staticRenderFns } from "./MerchReviewOffer.vue?vue&type=template&id=206a7d16"
import script from "./MerchReviewOffer.vue?vue&type=script&lang=js"
export * from "./MerchReviewOffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports